import { buildDocumentTitle } from "../utils/documentTitle";

export default function DocumentTitle({ title, selectedOrganisation }) {
  return <title>{buildDocumentTitle(title, selectedOrganisation)}</title>;
}
